export const WEB_MODE = 'WEB';
export const DESK_MODE = 'DESK';

export const COMPONENTS_DELETED_IN_NEW_FLOW_MODE = ['ComponentSwitcher', 'ComponentSwitcherDas', 'Building', 'PlanimetryDas', 'Floor', 'FloorDas'];

export const HAS_MORE_FLOORS_PARAMS = 'hasMoreFloors';
